import { useCallback, useEffect, useState } from "react";
import {
  getMerchantBrandCatalog,
  updateMerchantBrandCategories,
  updateMerchantBrandStatus,
} from "../api/merchantBrandAdmin.api";
import type { MerchantBrandCatalogListItem } from "../types/merchantBrandAdmin.types";

export function useMerchantBrandCatalog() {
  const [items, setItems] = useState<MerchantBrandCatalogListItem[]>([]);
  const [keyword, setKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const refetch = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getMerchantBrandCatalog({
        keyword: keyword || undefined,
      });
      setItems(response);
    } catch (requestError) {
      setError(
        requestError instanceof Error ? requestError.message : "Failed to load merchant brands",
      );
    } finally {
      setIsLoading(false);
    }
  }, [keyword]);
  useEffect(() => {
    void refetch();
  }, [refetch]);
  const saveCategories = async (id: string, merchantCategoryIds: string[]) => {
    await updateMerchantBrandCategories(id, { merchant_category_ids: merchantCategoryIds });
    await refetch();
  };
  const updateStatus = async (id: string, isActive: boolean) => {
    await updateMerchantBrandStatus(id, { is_active: isActive });
    await refetch();
  };

  return {
    items,
    keyword,
    isLoading,
    error,
    setKeyword,
    refetch,
    saveCategories,
    updateStatus,
  };
}
